import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/home/runner/work/mdsite4/mdsite4/components/core/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoginOrUserDesktop"] */ "/home/runner/work/mdsite4/mdsite4/components/layout/login-or-user-desktop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoginOrUserMobile"] */ "/home/runner/work/mdsite4/mdsite4/components/layout/login-or-user-mobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sheet","SheetTrigger","SheetContent","SheetHeader","SheetTitle"] */ "/home/runner/work/mdsite4/mdsite4/components/ui/sheet.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root","displayName","List","Item","Trigger","Content","Link","Viewport","Indicator"] */ "/home/runner/work/mdsite4/mdsite4/node_modules/@radix-ui/react-navigation-menu/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/mdsite4/mdsite4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/mdsite4/mdsite4/node_modules/next/dist/client/image-component.js");
